<template>
  <div class="register-page">
    <div class="register-container">
      <div class="register-left">
        <div class="register-brand">
          <div class="brand-icon">
            <i class="el-icon-s-opportunity"></i>
          </div>
          <h1>第一届明安图天文前沿论坛</h1>
          <p>The First Minggatu Forum on Astronomy Frontier </p>
        </div>
        <div class="register-benefits">
          <h3>注册后您将获得：</h3>
          <ul>
            <li><i class="el-icon-check"></i> 在线报名参会资格</li>
            <li><i class="el-icon-check"></i> 摘要投稿通道</li>
            <li><i class="el-icon-check"></i> 会议资料下载</li>
            <li><i class="el-icon-check"></i> 学术交流平台</li>
          </ul>
        </div>
      </div>

      <div class="register-right">
        <div class="register-form-container">
          <h2>参会注册</h2>
          <p class="register-subtitle">填写以下信息完成注册</p>

          <el-form 
            ref="registerForm" 
            :model="registerForm" 
            :rules="registerRules"
            class="register-form"
            label-position="top"
          >
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="姓名" prop="realname">
                  <el-input v-model="registerForm.realname" placeholder="请输入姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="registerForm.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="单位" prop="organization">
                  <el-input v-model="registerForm.organization" placeholder="请输入单位名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别" prop="gender">
                  <el-select v-model="registerForm.gender" placeholder="请选择性别" style="width: 100%;">
                    <el-option label="男" value="1"></el-option>
                    <el-option label="女" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="证件类型" prop="id_type">
                  <el-select v-model="registerForm.id_type" placeholder="请选择证件类型" style="width: 100%;">
                    <el-option label="身份证" value="idcard"></el-option>
                    <el-option label="护照" value="passport"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证件号码" prop="id_number">
                  <el-input v-model="registerForm.id_number" placeholder="请输入证件号码"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="职称/职务" prop="title">
                  <el-input v-model="registerForm.title" placeholder="请输入职称/职务"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="参会类型" prop="attend_type">
                  <el-select v-model="registerForm.attend_type" placeholder="请选择参会类型" style="width: 100%;">
                    <el-option label="邀请报告" value="invited"></el-option>
                    <el-option label="报告" value="report"></el-option>
                    <el-option label="海报" value="poster"></el-option>
                    <el-option label="其他" value="other"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="分会场" prop="sub_venue">
                  <el-select v-model="registerForm.sub_venue" placeholder="请选择分会场" style="width: 100%;">
                    <el-option label="银河系与恒星" value="1"></el-option>
                    <el-option label="星系与宇宙学" value="2"></el-option>
                    <el-option label="天文仪器与巡天" value="3"></el-option>
                    <!-- <el-option label="分会场四" value="4"></el-option> -->
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="住宿" prop="accommodation">
                  <el-select v-model="registerForm.accommodation" placeholder="请选择住宿方式" style="width: 100%;">
                    <el-option label="无" value="none"></el-option>
                    <el-option label="单住" value="single"></el-option>
                    <el-option label="合住" value="shared"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="报告名称" prop="report_title">
              <el-input v-model="registerForm.report_title" placeholder="请输入报告名称（如有）"></el-input>
            </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="mobile">
              <el-input v-model="registerForm.mobile" placeholder="请输入联系电话"></el-input>
            </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="设置密码" prop="password">
                  <el-input type="password" v-model="registerForm.password" placeholder="请设置密码（6-20位）" show-password></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="确认密码" prop="confirmPassword">
                  <el-input type="password" v-model="registerForm.confirmPassword" placeholder="请再次输入密码" show-password></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item>
              <el-button 
                type="primary" 
                :loading="loading" 
                @click="handleRegister"
                class="register-btn"
              >
                提交注册
              </el-button>
            </el-form-item>
          </el-form>

          <div class="register-footer">
            <span>已有账号？</span>
            <router-link to="/login">立即登录</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userApi } from '@/api'

export default {
  name: 'Register',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      registerForm: {
        realname: '',
        email: '',
        organization: '',
        gender: '',
        // id_type: '',
        // id_number: '',
        title: '',
        attend_type: '',
        report_title: '',
        mobile:'',
        sub_venue: '',
        accommodation: '',
        password: '',
        confirmPassword: ''
      },
      registerRules: {
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        organization: [
          { required: true, message: '请输入单位', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        // id_type: [
        //   { required: true, message: '请选择证件类型', trigger: 'change' }
        // ],
        // id_number: [
        //   { required: true, message: '请输入证件号码', trigger: 'blur' }
        // ],
        title: [
          { required: true, message: '请输入职务', trigger: 'blur' }
        ],
        attend_type: [
          { required: true, message: '请选择参会类型', trigger: 'change' }
        ],
        sub_venue: [
          { required: true, message: '请选择分会场', trigger: 'change' }
        ],
        accommodation: [
          { required: true, message: '请选择住宿方式', trigger: 'change' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请设置密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async handleRegister() {
      this.$refs.registerForm.validate(async (valid) => {
        if (!valid) return

        this.loading = true
        try {
          const { confirmPassword, ...data } = this.registerForm
          await userApi.register(data)
          
          this.$message.success('注册成功，请登录')
          this.$router.push('/login')
        } catch (error) {
          console.error('注册失败:', error)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.register-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0d1642 0%, #1a237e 100%);
  padding: 20px;
}

.register-container {
  display: flex;
  width: 100%;
  max-width: 1100px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.register-left {
  flex: 0 0 360px;
  background: linear-gradient(135deg, #1a237e 0%, #3949ab 50%, #7c4dff 100%);
  padding: 60px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(2px 2px at 20px 30px, rgba(255,255,255,0.3), transparent),
      radial-gradient(1px 1px at 60px 80px, rgba(255,255,255,0.4), transparent);
    background-size: 100px 100px;
  }
}

.register-brand {
  position: relative;
  z-index: 1;
  text-align: center;
  margin-bottom: 40px;

  .brand-icon {
    width: 70px;
    height: 70px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;

    i {
      font-size: 36px;
      color: #ffd700;
    }
  }

  h1 {
    color: #fff;
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
  }
}

.register-benefits {
  position: relative;
  z-index: 1;

  h3 {
    color: #ffd700;
    font-size: 16px;
    margin-bottom: 20px;
  }

  ul {
    list-style: none;

    li {
      color: rgba(255, 255, 255, 0.9);
      padding: 12px 0;
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 14px;

      i {
        color: #ffd700;
        font-size: 16px;
      }
    }
  }
}

.register-right {
  flex: 1;
  padding: 40px 50px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.register-form-container {
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  margin-right: -10px;

  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  h2 {
    font-size: 28px;
    color: #1a237e;
    margin-bottom: 8px;
  }

  .register-subtitle {
    color: #666;
    margin-bottom: 20px;
  }
}

.register-form {
  .el-form-item {
    margin-bottom: 14px;
  }

  ::v-deep .el-form-item__label {
    padding-bottom: 2px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
  }

  ::v-deep .el-input__inner {
    height: 38px;
    border-radius: 6px;
  }

  ::v-deep .el-select .el-input__inner {
    height: 38px;
  }

  .el-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  a {
    color: #1a237e;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.register-btn {
  width: 100%;
  height: 50px;
  font-size: 18px;
  border-radius: 8px;
  background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
  border: none;

  &:hover {
    background: linear-gradient(135deg, #3949ab 0%, #7c4dff 100%);
  }
}

.register-footer {
  text-align: center;
  margin-top: 24px;
  color: #666;

  a {
    color: #1a237e;
    font-weight: 600;
    text-decoration: none;
    margin-left: 8px;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media screen and (max-width: 768px) {
  .register-container {
    flex-direction: column;
  }

  .register-left {
    flex: none;
    padding: 30px;
  }

  .register-brand {
    margin-bottom: 20px;
  }

  .register-benefits {
    display: none;
  }

  .register-right {
    padding: 30px;
  }

  .register-form .el-col {
    width: 100%;
  }
}
</style>
